import React, {useRef} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const useStyles = makeStyles(theme=>({
  width:{
    position:(props)=>(props.fitted==true)?'relative':'fixed',
    top:(props)=>(props.fitted==true)?'':'32px',
    width:'100%',
    zIndex:'10',
    marginLeft:'0px',
    ['@media (min-width:960px)']:{
      marginLeft:(props)=>'0px',
      width:(props)=>'100%',
    },
  },
  tab_root:{
    textTransform:(props)=>(props.fontSize)?'none':'',
    minHeight:(props)=>(props.height)?props.height:'35px',
    height:(props)=>(props.height)?props.height:'',
    fontSize:(props)=>(props.fontSize)?props.fontSize:''
  },
  root: {
    width:'100%',
    height:(props)=>(props.height)?props.height:'35px',
    borderRadius:'0px',
    backgroundColor:(props)=>(props.white==true)?'white':theme.palette.tertiary.main,
    flexGrow: 1,
    marginLeft:(props)=>(props.fitted==true)?'0px':'-10px',
    ['@media (min-width:600px)']:{
      marginLeft:(props)=>(props.fitted==true)?'0px':'-19px',
    },
  },
}));

export default function CenteredTabs(props) {
  const classes = useStyles(props);
  const [value, setValue] = React.useState(0);
  let first_time=useRef(true);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabs=props.tabs

  let index=0; for(let x of tabs){if(window.location.pathname.includes(x.path) && value!=index){setValue(index);} index+=1;}
  if(first_time.current==true || props.permanent_initial_value==true){first_time.current=false; if(props.initial_value!=undefined && props.initial_value!=value){setValue(props.initial_value)}}
  return (
    <Slide timeout={(props.fitted==true)?0:500} direction={(props.fitted==true)?'':'down'} in={true} mountOnEnter={(props.fitted==true)?false:true} unmountOnExit={(props.fitted==true)?false:true}>
    <div className={classes.width}>
    <Paper className={classes.root}>
      <Tabs
        classes={{root:classes.tab_root}}
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        variant='scrollable'
        scrollButtons='auto'
        textColor="primary"
      >
      {tabs.map(function(tab){
        let tab_width=(props.tab_width!=undefined)?props.tab_width:(100/tabs.length)+'%';
        let title=tab.title;
        return(<Tab classes={{root:classes.tab_root}} style={{minWidth:(props.tabMinWidth!=undefined)?props.tabMinWidth:'130px', maxWidth:tab_width, width:tab_width}} label={title} onClick={()=>{if(tab.onClick!=undefined){tab.onClick(tab)}; if(tab.path!=undefined){props.history.push(tab.path)}}}/>);
      })}
      </Tabs>
    </Paper>
    </div>
    </Slide>
  );
}
